/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecureDetails {
    getFixupPrototypeFunction() { return SecureDetails.fixupPrototype; }

    static newInstance(model: Partial<SecureDetails>): SecureDetails {
        let obj = Object.assign(new SecureDetails(), model);
        SecureDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecureDetails>): SecureDetails {
        if (!model) return null;
        return SecureDetails.newInstance(<SecureDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecureDetails) {
        if (!obj) return;

        models.SecureDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecureDetails): boolean {
        Object.setPrototypeOf(obj, SecureDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.secure_scores) {
            models.SecureScoreDetails.fixupPrototype(this.secure_scores);
        }
        if (this.recommendations) {
            models.SecureScoreDerivedDetails.fixupPrototype(this.recommendations);
        }
    }

    /**
     * ID
     */
    id: string;

    /**
     * cloud account id
     */
    cloud_account_id: string;

    /**
     * Azure Subscription ID.
     */
    subscription_id: string;

    /**
     * When the schedule is created
     */
    created_at: string;

    /**
     * Who has created the schedule
     */
    created_by: string;

    /**
     * Id of the tenant
     */
    tenant_id: string;

    /**
     * Name of the tenant
     */
    tenant_name: string;

    /**
     * secure score for the cloud account
     */
    secure_scores: models.SecureScoreDetails;

    /**
     * Cloud Service Name
     */
    cloud_account_name: string;

    /**
     * Cloud Service Name
     */
    cloud_name: string;

    /**
     * Name of the subscription from Azure
     */
    subscription_name: string;

    /**
     * Date and Time of Update
     */
    updated_at: string;

    /**
     * Who has updated the secure score
     */
    updated_by: string;

    /**
     * Secure score deatils
     */
    recommendations: models.SecureScoreDerivedDetails;

}
